import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
import Cache from '../cache/cache';
// 国家列表
export default async function guojiaList(context: Context, params: CustomQuery): Promise<ApiResult> {
  const cacheKey = 'guojiaList_' + JSON.stringify(params);
  const cache = Cache.getCache(context, cacheKey);
  if (cache) {
    return cache;
  }
  const url = new URL('/mall/address/receiving_country', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  Cache.setCache(context, cacheKey, res);
  return res;
}
